import { connect } from 'react-redux';
import { 
  Header
} from '../components';

function mapStateToProps (state) {
  return {data: state.navItems};
}

export default connect(mapStateToProps)(Header);



// WEBPACK FOOTER //
// ./usr/lib/ui/src/containers/Header.js